import React, { useState, useContext } from 'react'
import { Toast } from './../UI/toast/Toast'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import { fetchProperties } from '../../helpers/api/condominium'
import { CurrencyContext } from "../../context/Context";
import PageHeader from '../common/PageHeader'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import { useParams } from 'react-router'
import { useLocation } from 'react-router-dom'
import { createAliquot, createIncome } from '../../helpers/api/finance'
import { useSelector } from 'react-redux'
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination'
import { PreloadState } from '../UI/preloading/PreloadState'
import SupportLink from '../root/support/components/SupportLink'
import CreateCommonIncomeForm from './CreateCommonIncomeForm'
import CreditPaymentForm from '../credit/CreditPayment'
import { getFinanceModuleBase } from '../../helpers/utils'

const CreateCommonIncome = ({ setRedirectUrl, setRedirect }) => {

    const { id } = useParams();
    const { currency: curr } = useContext(CurrencyContext);
    const activeExchangeRate = Number(curr?.value ?? 0);
    const location = useLocation();
    const moduleBase = getFinanceModuleBase(location.pathname);
    const { selectedCondominium } = useSelector(state => state.condominium);
    const [params] = useState({
        condominiumId: selectedCondominium
    })
    const {
        data,
        isLoading,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(fetchProperties, params);
    

    const create = async values => {
        const {
            voucher,
            name,
            description,
            period_id,
            reference,
            bank_name,
            amount,
            is_common_type,
            reserve_fund_id,
            anyfund,
          } = values;
        try {

            let formData = new FormData();
            formData.append("name", name);
            formData.append("period_id", period_id);
            formData.append("description", description);
            formData.append("bank_name", bank_name);
            /* formData.append("reserve_fund_id", reserve_fund_id); */
            formData.append("reference", reference);
            formData.append("condominium_id", id);
            formData.append("amount", amount);
            if (activeExchangeRate) formData.append("rate", activeExchangeRate);
            formData.append("is_common_type", 1);

            console.log(anyfund)

            if (anyfund) formData.append("reserve_fund_id", reserve_fund_id);
            

            if (voucher) formData.append("voucher", voucher);

            const { code } = await createIncome(formData);

            if (code === SUCCESS_RESPONSE.CREATED) {
                setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-income`);
                setRedirect(true);
                Toast.fire({
                    type: 'success',
                    title: `Ingreso registrado exitosamente.`,
                });
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    return <>
        <PageHeader
            title="Añadir ingreso común"
            titleTag="h2"
            description="Registra un ingreso común."
            className="mb-3"
            col={{ lg: 9 }}
        >
            <SupportLink/>
        </PageHeader>
        <PreloadState loading={isLoading}>
            <CreateCommonIncomeForm setRedirect={setRedirect} setRedirectUrl={setRedirectUrl} handleSubmitData={create} handler={{ nextPage, previousPage, perPage, goToPage, meta }} properties={data} />
        </PreloadState>
    </>
}

export default withRedirect(CreateCommonIncome);